import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=316962fc&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=316962fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316962fc",
  null
  
)

export default component.exports